import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import { CREW_STATISTICS_CATALOG } from './statisticsCatalog';

const CrewStatisticsHub: React.FC = () => {
  const { colors } = useTheme();

  return (
    <div className="space-y-8">
      {CREW_STATISTICS_CATALOG.map((group) => (
        <section key={group.name}>
          <div className="mb-3">
            <h2 className={cn('text-sm font-semibold uppercase tracking-wider', colors.text)}>{group.name}</h2>
            <p className={cn('text-xs mt-0.5', colors.textMuted)}>{group.description}</p>
          </div>
          <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
            {group.items.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={cn(
                  'group rounded-xl border p-4 transition-all',
                  colors.surface,
                  colors.border,
                  'hover:shadow-md',
                  colors.interactiveHover,
                )}
              >
                <div className={cn('font-medium text-sm', colors.text)}>
                  {item.name}
                </div>
                <p className={cn('mt-1.5 text-xs leading-relaxed', colors.textMuted)}>{item.description}</p>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default CrewStatisticsHub;
